import { merge, Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { logError } from 'services/logger';

const error$ = new Subject<any>();

type CreateRoutinesStreamsTuple = [
  (...args: Observable<any>[]) => Observable<any>,
  Observable<any>[]
];

const getStateRoutines = () => {
  const routines = [] as CreateRoutinesStreamsTuple[];

  return merge(
    ...routines.map(([getRoutine, streams]) => getRoutine(...streams))
  );
};

const subscribeStateRoutine = (
  stateRoutineToSubscribe: Observable<unknown>,
  errorSubject: Subject<any>
) =>
  stateRoutineToSubscribe
    .pipe(
      catchError((err, stream) => {
        errorSubject.next(err);
        return stream;
      })
    )
    .subscribe();

export default function startStateRoutines() {
  const stateRoutineSubscription = subscribeStateRoutine(
    getStateRoutines(),
    error$
  );
  const errorSubscription = error$.subscribe((error) =>
    logError(error?.message)
  );

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      stateRoutineSubscription.unsubscribe();
      errorSubscription.unsubscribe();
    });
  }
}
